import { Action } from "@ngrx/store";
import Me from "./state";

export enum MeActionTypes {
    GET_ME = "[Me] Get Me",
    GET_ME_SUCCESS = "[Me] Get Me Success",
    GET_ME_FAIL = "[Me] Get Me FAIL",
}

export class GetMeAction implements Action {
    readonly type = MeActionTypes.GET_ME;
}

export class GetMeSuccessAction implements Action {
    readonly type = MeActionTypes.GET_ME_SUCCESS;
    constructor(public payload: Me) {}
}

export class GetMeFailAction implements Action {
    readonly type = MeActionTypes.GET_ME_FAIL;
    constructor(public payload: any) {}
}

export type MeAction = GetMeAction | GetMeSuccessAction | GetMeFailAction;
